module.exports = __webpack_public_path__ + "img/신촌 고깃집.eea8566f.png";